// extracted by mini-css-extract-plugin
module.exports =  {"file-drop-container":"file-drop-container-hPBXO"};